const backEnd = process.env.REACT_APP_BACK_END;
const log = process.env.REACT_APP_LOGIN;
export const baseName = process.env.REACT_APP_BASE_NAME || '';

export const urls = {
   backEnd,
   graph: backEnd + '/graphql',
   logIn: backEnd + '/login',
   logOut: backEnd + '/logout',
   verify: backEnd + '/verify'
};
export const urlsLog = {
   log,
   graph: log + '/graphql'
};
export const prioridades = {
   0: 'Baja',
   1: 'Moderada',
   3: 'Alta',
   4: 'Crítica'
};
export const apiRestUrl = process.env.REACT_APP_API_REST;
export const dslogin = process.env.REACT_APP_API_DSCENTRAL;
